import React, { useEffect, useState, memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import style from "../../../../styles/gri/general.module.css";
import {  validateNumberInput, validatePercentageInput } from "../../../../utils/validateFields";
import { getRowErrorMessages } from "../../../../utils/getRowErrorMessage";


const TableComponent = memo(
  ({ inputData, subHeading, tables, setTables, errors, setErrors, data , disabled}) => {
    useEffect(() => {
      setTables(
        inputData?.map((section) => ({
          fieldName: section?.fieldName,
          rows:
            data?.[section?.fieldName]?.length > 0
              ? data[section?.fieldName]
              : [{}],
        }))
      );
      console.log(tables,"h1")

    }, [data]);

    

   

    const handleInputChange = (
      tableIndex,
      rowIndex,
      fieldName,
      value,
      type,
      options
    ) => {
      if (type === "percentage" && !validatePercentageInput(value)) return;
      if (type === "number" && !validateNumberInput(value)) return;
      console.log(fieldName,value,"dataOfDynamicTables")
      const updatedTables = [...tables];

      let value2 = options?.includes("Select All")
        ? value?.includes("Select All")
          ? value?.length < options?.length && value?.length !== 1
            ? value?.[value?.length - 1] === "Select All"
              ? options
              : value?.filter((el) => el !== "Select All")
            : options
          : value?.length ===
            options?.filter((el) => el !== "Select All").length
          ? []
          : value
        : value;

      updatedTables[tableIndex].rows[rowIndex][fieldName] = value2;

      const updatedErrors = { ...errors };
      if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
        delete updatedErrors[tableIndex][rowIndex][fieldName];
        if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
          delete updatedErrors[tableIndex][rowIndex];
        }
        if (Object.keys(updatedErrors[tableIndex]).length === 0) {
          delete updatedErrors[tableIndex];
        }
      }
      console.log(tables);
      setErrors(updatedErrors);
      setTables(updatedTables);
    };


    return (
      <Box sx={{ mt: "2rem" }}>
        {subHeading && <p className={style.subHeading}>{subHeading}</p>}
        {inputData?.map((section, tableIndex) => (
          <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                textIndent: "-1rem",
                paddingLeft: "1rem",
              }}
              gutterBottom
            >
              {section.title}
            </Typography>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "10px",
                ml: 2,
                width: "98.5%",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                        textAlign: "center",
                      }}
                    >
                      S. No.
                    </TableCell>
                    {section?.fields?.map((field) => (
                      <TableCell
                        key={field?.fieldName}
                        style={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width,
                          maxWidth: field.width,
                        }}
                      >
                        {field?.title}
                      </TableCell>
                    ))}
                  
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                    console.log(row, "checking row");
                    return (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          "& > th": {
                            color: "white",
                            fontWeight: "bold",
                            py: "0.5rem",
                            px: "0.5rem",
                            border: "1px solid rgba(224, 224, 224, 1)",
                            height: "auto",
                          },
                        }}
                      >
                        <TableCell sx={{ textAlign: "center", width: "8%" }}>
                          {rowIndex + 1}.
                        </TableCell>
                        {section?.fields?.map((field) => (
                          <TableCell
                            key={field?.fieldName}
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              width: field.width,
                              maxWidth: field.width,
                              height: "auto",
                            }}
                          >
                            {field.type === "select" ? (
                              <Select
                                multiple={field?.multiselect}
                                disabled={disabled}
                                multiline
                                minRows={1}
                                placeholder="Select"
                                value={
                                  field?.multiselect
                                    ? row[field?.fieldName] || [
                                    ] // Ensure array for multiselect
                                    : row[field?.fieldName] || "" // Ensure string for single select
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type,
                                    field.options
                                  )
                                }
                                displayEmpty
                                fullWidth
                                size="small"
                                sx={{
                                  border: "none",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }}
                                renderValue={(selected) => {
                                  if (selected?.includes("Select All")) {
                                    return selected
                                      ?.filter(
                                        (option) => option !== "Select All"
                                      )
                                      ?.join(", "); // Display custom text when "Select All" is selected
                                  }
                                  return field?.multiselect&&  selected?.length > 0
                                    ? selected?.join(", ") :selected?.length===0 ? "Select"
                                    :selected ||  "Select";
                                }}
                              >
                                <MenuItem value={"" || []} disabled>
                                  {field.placeholder || "Select"}
                                </MenuItem>
                                {field.options?.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option?.name || option} // Ensure the `value` matches the `row[field.fieldName]`
                                  >
                                    {field.multiselect ? (
                                      <>
                                        <Checkbox
                                        disabled={disabled}
                                          checked={
                                            row[field.fieldName]?.includes(
                                              option?.name || option
                                            ) || false
                                          } // Check if the option is selected
                                          size="small"
                                        />
                                        {option?.name || option}
                                      </>
                                    ) : (
                                      option?.name || option
                                    )}
                                  </MenuItem>
                                ))}
                              </Select>
                            ) : field.type === "radio" ? (
                              // console.log(row,row[field.fieldName],"Checking...")
                              <Box sx={{ display: "flex" }}>
                                <FormControl sx={{ my: 1, display: "flex" }}>
                                  <RadioGroup
                                    row
                                    value={row[field.fieldName] || "Yes"}
                                    onChange={(e) =>
                                      handleInputChange(
                                        tableIndex,
                                        rowIndex,
                                        field.fieldName,
                                        e.target.value,
                                        field.type
                                      )
                                    }
                                    disabled={disabled}
                                  >
                                    <FormControlLabel
                                      value="Yes"
                                      control={<Radio />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            ) : (
                              <TextField
                                placeholder={field.placeholder}
                                type={field.type}
                                value={row[field.fieldName] || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                multiline
                                minRows={1}
                                disabled={field.fieldName === 'location' || disabled}
                                sx={{
                                  width: "100%",
                                  py: "0.5rem",
                                  "& .MuiInputBase-root": {
                                    overflowY: "auto",
                                    cursor: "default", // default cursor
                                    fontWeight: field.fieldName === 'location' ? "600" : "normal", // Bold for location
                                    color: field.fieldName === 'location' ? "#000000" : "#000000",     // Darker color when disabled
                                  },
                                  "& .MuiInputBase-root:hover": {
                                    cursor: "pointer", // pointer cursor on hover
                                  },
                                }}
                                size="small"
                                variant="standard"
                                InputProps={{ disableUnderline: true, }}
                              />
                            )}
                          </TableCell>
                        ))}

                       
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 1, ml: 3 }}>
              {Object.keys(errors).length > 0 &&
                getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                  (errorMessage, idx) => (
                    <p
                      key={idx}
                      color="error"
                      variant="caption"
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )
                )}
            </Box>
            
          </div>
        ))}
      </Box>
    );
  }
);

export default TableComponent;
